var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{staticClass:"d-none d-sm-block",class:{
            'px-8': !_vm.noPadding
        },attrs:{"src":_vm.srcDesktop,"width":"100%"}}),_c('img',{staticClass:"d-sm-none",attrs:{"src":_vm.srcMobile,"width":"100%"}}),_c('h1',[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }